
























import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class App extends Vue {
  // props:
  @Prop({ type: String, required: true })
  private readonly url!: string;
}
